import Link from '../../Link';

import styles from './styles.module.scss';

export const Legal = ({ legalMenu, theme }) => (
  <div className={styles.text}>
    {legalMenu?.map?.((link) => (
      <span key={link.sys.id} className={styles.legalLink}>
        <Link theme={theme} link={link} />
        <span className={styles.legalDot}>&middot;</span>
      </span>
    ))}
  </div>
);
